var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 158,
    viewBox: "0 0 320 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left SVG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 154.673V0H262.873C266.761 62.6811 259.388 84.9814 231.632 105.124C191.284 115.015 170.607 117.175 130.767 107.802C104.615 95.0781 91.146 97.5569 69.1771 118.515C53.1102 139.942 22.3152 134.585 0 154.673Z",
    fill: "#D1F9F0",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 154.673V0H262.873C266.761 62.6811 259.388 84.9814 231.632 105.124C191.284 115.015 170.607 117.175 130.767 107.802C104.615 95.0781 91.146 97.5569 69.1771 118.515C53.1102 139.942 22.3152 134.585 0 154.673Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M47.3082 75.6624C72.1195 55.9607 85.4497 35.6745 104.881 0H320C303.382 10.7551 299.423 15.374 298.131 22.0961C293.401 40.3589 278.006 44.8296 237.434 46.8705C168.546 123.883 126.177 133.155 47.3082 75.6624Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M0 157.351V0H210.209C201.377 22.4816 193.717 33.8582 175.844 52.2271C153.624 76.1581 135.355 80.5366 94.6165 75.6624C80.6232 85.5653 74.8229 95.1414 68.2845 119.855C56.2343 135.255 46.4523 135.84 29.0098 138.603C16.5132 140.582 4.79718 146.038 0 157.351Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 293.643,
    y1: 174.707,
    x2: 94.8137,
    y2: -15.9626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 198.411,
    y1: 14.8344,
    x2: 270.691,
    y2: 58.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.0000561591,
    y1: 93.5102,
    x2: 429.934,
    y2: 14.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99B740",
    stopOpacity: 0.59
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSvg);
export default __webpack_public_path__ + "static/media/leftSVG.ed44e3d8.svg";
export { ForwardRef as ReactComponent };